import React, { useEffect, useState } from "react";
import { KoSelect, KoAvatar,  KoButton, KoTooltips, KoSegmented, KoStaicGroups, KoStaicMembers, KoTitle, KoToast, KoLoader } from "packages";
import KoIcon from '@kwapio/icons';
import { useSelector } from "react-redux";
import { Form } from "antd";
import styles from "./drive.module.scss";
import { FilesAPI } from "./files.service";

function FileShareCrud({ form, handleFinish, initialValues, currentFolder, callback, souce }) {
  const users = useSelector((state) => state?.users?.data || []);
  const [active, setActive] = useState('Shared with');
  const groups = useSelector((state) => state?.groups?.data || []);
  const [loading, setLoading] = useState(false);
  const [shareDetails, setShareDetails] = useState(souce === 'folder' ? currentFolder : initialValues);


  const permissionOptions = [
    { label: "Viewer", value: 0 },
    { label: "Editor", value: 1 },
    { label: "Commenter", value: 2 }
  ];

  useEffect(() => {
    form.setFieldValue(["sharedWith", "groups"], [{}]);
    form.setFieldValue(["sharedWith", "users"], [{}]);
  }, [form, initialValues]);

  useEffect(() => {
    setShareDetails(souce === 'folder' ? currentFolder : initialValues);
  }, [currentFolder, initialValues]);


  const handleRevoke = (id) => {
    let obj = {
      "documentId": initialValues?.documentId || currentFolder?.folderId,
      "id": id
    };
    let folderId = currentFolder?.folderId;
    setLoading(true);
    FilesAPI.removeFileAccess(obj, folderId).then(
      (data) => {
        callback && callback();
        setLoading(false);
        KoToast.success(`Permission removed successfully!`);
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };

  return (
    <div className={styles.shareWraper}>
      {loading&& <KoLoader/>}
      <KoSegmented className={styles.segmented} options={["Shared with", "Remove access"]} value={active} onChange={setActive} />
      {active === "Shared with" ?<Form form={form} onFinish={handleFinish}  layout="vertical">
        {/* Grant Access to Groups */}
        <Form.List name={["sharedWith", "groups"]}>
          {(fields, { add, remove }) => {
            const selectedGroupIds = form.getFieldValue(["sharedWith", "groups"])?.map((g) => g?.groupId) || [];

            return (
              <div className={styles.userList}>
                {fields.map(({ key, name, ...restField }, index) => (
                  <div key={key} className={styles.groupList}>
                    <Form.Item
                      {...restField}
                      name={[name, "groupId"]}
                      label={index === 0 ? "Grant Access to Groups" : ""}
                    >
                      <KoSelect
                        showSearch
                        placeholder="Select Group"
                        options={groups.map((group) => ({
                          label: group?.name,
                          value: group?.groupId,
                          disabled: selectedGroupIds.includes(group?.groupId)
                        }))}
                      />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "permission"]}
                      label={index === 0 ? "Permission" : ""}
                    >
                      <KoSelect options={permissionOptions} placeholder="Select Permission" />
                    </Form.Item>

                    <div>
                      {index === 0 && <label>&nbsp;</label>}
                      <div className={styles.actions}>
                        {fields.length > 1 && (
                          <KoButton
                            iconBtn={true}
                            icon={<KoIcon name={"DeleteOutlined"} />}
                            onClick={() => remove(name)}
                          />
                        )}
                        {index === fields.length - 1 && (
                          <KoTooltips title={"Add Group"}>
                            <KoButton
                              iconBtn={true}
                              icon={<KoIcon name={"PlusOutlined"} />}
                              onClick={() => add()}
                            />
                          </KoTooltips>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            );
          }}
        </Form.List>

        {/* Grant Access to Users */}
        <Form.List name={["sharedWith", "users"]}>
          {(fields, { add, remove }) => {
            const selectedUserIds = form.getFieldValue(["sharedWith", "users"])?.map((u) => u?.userId) || [];

            return (
              <div className={styles.userList}>
                {fields.map(({ key, name, ...restField }, index) => (
                  <div key={key} className={styles.groupList}>
                    <Form.Item
                      {...restField}
                      name={[name, "userId"]}
                      label={index === 0 ? "Grant Access to People" : ""}
                    >
                      <KoSelect
                        showSearch
                        placeholder="Select User"
                        options={users.map((user) => ({
                          label: (
                            <>
                              <KoAvatar
                                inLine={"0rem"}
                                size={20}
                                options={[{ name: user?.profile?.firstName, logo: user?.profile?.logo }]}
                              />{" "}
                              {user.profile?.firstName + " " + user.profile?.lastName}
                            </>
                          ),
                          value: user?.userId,
                          disabled: selectedUserIds.includes(user?.userId)
                        }))}
                      />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "permission"]}
                      label={index === 0 ? "Permission" : ""}
                    >
                      <KoSelect options={permissionOptions} placeholder="Select Permission" />
                    </Form.Item>

                    <div>
                      {index === 0 && <label>&nbsp;</label>}
                      <div className={styles.actions}>
                        {fields.length > 1 && (
                          <KoButton
                            iconBtn={true}
                            icon={<KoIcon name={"DeleteOutlined"} />}
                            onClick={() => remove(name)}
                          />
                        )}
                        {index === fields.length - 1 && (
                          <KoTooltips title={"Add User"}>
                            <KoButton
                              iconBtn={true}
                              icon={<KoIcon name={"PlusOutlined"} />}
                              onClick={() => add()}
                            />
                          </KoTooltips>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            );
          }}
        </Form.List>
      </Form> : <div className={styles.revokeAccess}>
        {shareDetails?.sharedWith?.groups?.length > 0 && <KoTitle text="Remove Group Access" level={5} className={styles.title} />}
        {
          shareDetails?.sharedWith?.groups?.map((g) => (
            <div key={g?.groupId} className={styles.groupList}>
              <KoStaicGroups data={g?.profile} />
              <div className={styles.groupPermission}>
                <KoTitle text={g?.permission === 0 ? "Viewer" : g?.permission === 1 ? "Editor" : "Commenter"} level={5} className={styles.titlePermission} />
                <KoButton iconBtn={true} icon={<KoIcon name={"DeleteOutlined"} />} onClick={() => handleRevoke(g?.groupId)} />
              </div>
            </div>
          ))
        }
        {shareDetails?.sharedWith?.users?.length > 0 &&  <KoTitle text="Remove People Access" level={5} className={styles.titleUsers} />}
        {
          shareDetails?.sharedWith?.users?.map((u) => (
            <div key={u?.userId} className={styles.groupList}>
              <KoStaicMembers data={u?.profile} />
              <div className={styles.groupPermission}>
                <KoTitle text={u?.permission === 0 ? "Viewer" : u?.permission === 1 ? "Editor" : "Commenter"} level={5} className={styles.titlePermission} />
                <KoButton iconBtn={true} icon={<KoIcon name={"DeleteOutlined"} />} onClick={() => handleRevoke(u?.userId)} />
              </div>

            </div>
          ))
        }
      </div>}
    </div>
  );
}

export default FileShareCrud;
